var _defs, _g, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.75,
    x2: 37.25,
    y1: 29.91,
    y2: 48.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 7.5h64v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 39,
    r: 10.5,
    fill: "url(#b)",
    stroke: "#f8af18",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M32 22.71V16.5m0 45v-6.21m11.52-27.81l4.39-4.39M16.09 54.91l4.39-4.39m0-23l-4.39-4.39m31.82 31.78l-4.39-4.39M15.71 39H9.5m45 0h-6.21"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 32 39; 360 32 39"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 42.5h11l5 4.5 5-4.5h11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.89562883e8691c69a12f126cad1d76d5.svg";
export { ForwardRef as ReactComponent };